import { createFetchAction } from '../utils';
import * as rawMatActionTypes from './rawMatActionTypes';

export const fetchRawMatActions = createFetchAction(rawMatActionTypes.FETCH_RAWMAT_ACTIONS, 'rawMatActionId');
